import moment from "moment";
import { Projet } from "../../../../../../utils/api/launchCampagn/projet.type";
import { useRetraitsQuery } from "../../../../../../utils/api/retrait/retrait.api";
import {
  destinationRetrait,
  origineVersement,
  RETRAIT_STATUT,
} from "../../../../../../utils/api/retrait/retrait.type";
import { formatMontant } from "../../../../../../utils/utils";


// Historique des retraits du projet, avec leur statut. Le porteur suit ici ce
// qu'il a demande et ou chaque versement en est.
function RetraitsProjet({ item }: { item: Projet }) {
  const { data: retraits = [], isLoading } = useRetraitsQuery({
    projet: item?.id,
  });

  return (
    <div>
      <div className="row mb-4">
        {[
          { label: "Collecté", valeur: item?.funds, couleur: "#021849" },
          {
            label: "Disponible au retrait",
            valeur: item?.montant_total_restant,
            couleur: "#0FBF56",
          },
          {
            label: "Déjà versé",
            valeur: item?.montant_total_debit,
            couleur: "#6c757d",
          },
        ].map((c) => (
          <div className="col-md-4 col-6 mb-2" key={c.label}>
            <div
              style={{
                background: "#fff",
                borderLeft: `4px solid ${c.couleur}`,
                boxShadow: "0px 2px 10px rgba(0,0,0,0.06)",
                borderRadius: 4,
                padding: "12px 14px",
              }}
            >
              <div style={{ fontSize: 12, color: "rgba(0,0,0,0.6)" }}>
                {c.label}
              </div>
              <div style={{ fontWeight: 600, fontSize: 18, color: "#021849" }}>
                {formatMontant(c.valeur)}
              </div>
            </div>
          </div>
        ))}
      </div>

      {isLoading && <p>Chargement…</p>}
      {!isLoading && retraits.length === 0 && (
        <p className="modal-investissement-description">
          Aucune demande de retrait sur ce projet.
        </p>
      )}

      {retraits.length > 0 && (
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Montant</th>
                <th>Reçu</th>
                <th>Destination</th>
                <th>Statut</th>
                <th>Versement</th>
                <th>Motif</th>
              </tr>
            </thead>
            <tbody>
              {retraits.map((r) => {
                const st = RETRAIT_STATUT[r.statut];
                return (
                  <tr key={r.slug}>
                    <td>{moment(r.created_at).format("DD/MM/YYYY")}</td>
                    <td>{formatMontant(r.montant)}</td>
                    <td>{formatMontant(r.montant_net)}</td>
                    <td style={{ fontSize: 12 }}>{destinationRetrait(r)}</td>
                    <td>
                      <span style={{ color: st?.color, fontWeight: 600 }}>
                        {st?.label || r.statut}
                      </span>
                    </td>
                    <td style={{ fontSize: 12 }}>
                      {(() => {
                        const o = origineVersement(r);
                        if (!o) return "—";
                        return (
                          <>
                            <span style={{ fontWeight: 600, color: o.auto ? "#0FBF56" : "#6c757d" }}>
                              {o.label}
                            </span>
                            <div style={{ fontSize: 11, color: "rgba(0,0,0,0.5)" }}>
                              {o.reference}
                            </div>
                          </>
                        );
                      })()}
                    </td>
                    <td style={{ maxWidth: 220 }}>{r.motif || "—"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default RetraitsProjet;
